import { select } from 'redux-saga/effects';
import {
  ACT_APP_STARTING,
  ACT_APP_STARTED,
} from '../constants/actions';

const defaultState = {
  isAppLoading: true,
};

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_APP_STARTING:
      return {
        ...state,
        isAppLoading: true,
      };
    case ACT_APP_STARTED: {
      const { didLoadCountries } = select(globalState => globalState.countries);
      const { didLoadDynasties } = select(globalState => globalState.dynasties);
      const { didLoadUsers } = select(globalState => globalState.users);
      return {
        ...state,
        isAppLoading: didLoadCountries === true
          && didLoadDynasties === true
          && didLoadUsers === true,
      };
    }
    default:
      return state;
  }
};

export default appReducer;
